import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Usuario/obtenerNotificaconesUsuario`, method: 'GET', body: null, token: token})
}